import { create } from 'zustand';
import { ProductConditionType, ProductLine } from 'types';
import { PRODUCT_CONDITION_TYPES } from 'utils/constants';

interface ProductState {
  currentProduct: ProductLine | null;
  setCurrentProduct: (product: ProductLine | null) => void;
  isProductNew: boolean | null;
  setProductNew: (isNew: boolean | null) => void;
  productCondition: ProductConditionType | null;
  setProductCondition: (condition: ProductConditionType | null) => void;
  productId: string;
  setProductId: (id: string) => void;
  reset: () => void;
}

export const useProductStore = create<ProductState>((set) => ({
  currentProduct: null,
  setCurrentProduct: (product: ProductLine | null) => set({ currentProduct: product }),
  isProductNew: false,
  productCondition: PRODUCT_CONDITION_TYPES.UNUSABLE,
  setProductCondition: (condition: ProductConditionType | null) =>
    set({ productCondition: condition }),
  setProductNew: (isNew: boolean | null) =>
    set({
      isProductNew: isNew,
      productCondition: isNew
        ? PRODUCT_CONDITION_TYPES.NO_PACKAGING
        : PRODUCT_CONDITION_TYPES.UNUSABLE,
    }),
  productId: '',
  setProductId: (id: string) => set({ productId: id }),
  reset: () =>
    set({
      currentProduct: null,
      isProductNew: false,
      productCondition: PRODUCT_CONDITION_TYPES.UNUSABLE,
    }),
}));
